import { defineStore } from "pinia";
import { computed, ref } from "vue";

export const useGlobal = defineStore("global", () => {
  const registeredApplianceAvailable = ref(false);
  const hasCheckedShopCountry = ref(false);
  const showOrders = ref(true);
  const language = ref("de");
  const country = ref("DE");
  const locale = ref(`${language}_${country}`);

  const orders = ref(null);
  const appliances = ref(null);
  const userData = ref(null);
  const preloadedData = ref(false);

  const accessoryShopUrl = ref("");
  const customerServiceUrl = ref("");

  return {
    registeredApplianceAvailable,
    hasCheckedShopCountry,
    showOrders,
    country,
    language,
    locale,
    orders,
    appliances,
    userData,
    preloadedData,
    accessoryShopUrl,
    customerServiceUrl
  };
});
